import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BusinessIcon from "@mui/icons-material/Business";
import HandshakeIcon from "@mui/icons-material/Handshake";
import SettingsIcon from "@mui/icons-material/Settings";

import { PERMISSIONS } from "../../constants";
import HubGrid, { HUB_ICON_SX, HubNoAccess } from "./HubGrid";
import { canSeeAgreements, hasBothBranches, isExtensionAdmin } from "./extensionAccess";

// Rama de Convenios dentro de Extensión: los convenios, las entidades con las
// que se firman y la configuración que gobierna a ambos.
export default function AgreementsHub() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.value);

  const allowed = canSeeAgreements(user);

  const options = useMemo(() => {
    const perms = user?.permissions || [];
    const isAdmin = isExtensionAdmin(user);
    const items = [];
    if (perms.includes(PERMISSIONS.AGREEMENT.LIST) || isAdmin) {
      items.push({
        key: "agreements",
        label: "Convenios",
        description: "Registro de convenios y contratos, con su valor comprometido y saldo.",
        icon: <HandshakeIcon sx={HUB_ICON_SX} />,
        path: "/agreements",
      });
    }
    if (perms.includes(PERMISSIONS.ENTITY.LIST) || isAdmin) {
      items.push({
        key: "entities",
        label: "Entidades",
        description: "Las organizaciones con las que se firman los convenios, y su documentación.",
        icon: <BusinessIcon sx={HUB_ICON_SX} />,
        path: "/entities",
      });
    }
    if (isAdmin) {
      items.push({
        key: "config",
        label: "Configuración",
        description: "Documentos que debe entregar cada tipo de entidad, sectores y cifras del tablero.",
        icon: <SettingsIcon sx={HUB_ICON_SX} />,
        path: "/agreements/config",
      });
    }
    return items;
  }, [user]);

  useEffect(() => {
    if (options.length === 1 && options[0].path) {
      navigate(options[0].path, { replace: true });
    }
  }, [options, navigate]);

  if (!allowed) {
    return (
      <HubNoAccess
        title="Sin acceso a Convenios"
        message="Tu usuario no tiene permisos para el módulo de convenios."
      />
    );
  }
  if (options.length === 1) return null;

  return (
    <HubGrid
      title="Convenios"
      subtitle="Selecciona una opción"
      options={options}
      backTo={hasBothBranches(user) ? "/extension/inicio" : null}
      backLabel="Extensión"
    />
  );
}
